module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary",
    class: {
      open: _vm.dropdown
    },
    attrs: {
      "id": "section-summary"
    }
  }, [_c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "more-title"
  }, [_vm._v(_vm._s(_vm.section.title) + " Summary")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdown),
      expression: "dropdown"
    }],
    staticClass: "show-more"
  }, [(_vm.section.section === 'population') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Population'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('population'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('population_change'))
    }
  })]) : (_vm.section.section === 'urban-extent') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Urban Extent in Hectares'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('urban_extent_actuals'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('urban_extent_change'))
    }
  })]) : (_vm.section.section === 'density') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Built-up Area Density (Person/Hectare)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('density_built_up'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('density_built_up_change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Urban Extent Density (Person/Hectare)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('density_urban_extent'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('density_urban_extent_change'))
    }
  })]) : (_vm.section.section === 'composition-of-added-area') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t12_23Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Added Built-up Area in hectares'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT12_23('added_area_total'))
    }
  })]) : (_vm.section.section === 'roads') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Average Road Width (m)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('roads_average_width'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Share of built up area occupied by roads'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('roads_in_built_up_area', true))
    }
  })]) : (_vm.section.section === 'arterial-roads') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Density of Arterial Roads (km/km&sup2;)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('arterial_roads_density_all'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Share of built up area within walking distance of an arterial road'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('arterial_roads_walking_all', true))
    }
  })]) : (_vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Average Block Size (hectares)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('blocks_plots_average_block'))
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bcebf68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionSummary.vue
// module id = 299
// module chunks = 1